import React from 'react';
import { Wrapper } from './components/Wrapper';
import './App.scss';

function App() {
  return (
    <div className="App">
      <Wrapper />
    </div>
  );
}

export default App;
